import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/accounts/_layout/')({
  component: () => null,
});
